module.exports = __webpack_public_path__ + "static/img/stop.054b9876.png";